<template>
    <div class="upload-data">
        <div :class="{ 'upload-data-inner': true, 'upload-data-inner-stopscroll': isStopScroll }">
            <!-- 营业执照 -->
            <div class="business-license each-upload">
                <div class="upload-data-content-title">
                    <span class="color-red">*</span>营业执照<span
                        class="color-gray upload-data-content-title-limitdesc">（2M以内，支持png、jpg、jpeg格式）</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" :upload-id="0" />
                </div>
            </div>
            <!-- 法人身份证 -->
            <div class="id-card each-upload">
                <div class="upload-data-content-title">
                    <span class="color-red">*</span>法人身份证<span
                        class="color-gray upload-data-content-title-limitdesc">（2M以内，支持png、jpg、jpeg格式）</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" frame-desc="身份证国徽面照片" :upload-id="1" />
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" frame-desc="身份证头像面照片" :upload-id="2" />
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" frame-desc="法人手持身份证头像面照片" :upload-id="3" />
                </div>
            </div>
            <!-- 变更申请表 -->
            <div class="application each-upload">
                <div class="upload-data-content-title">
                    <span class="color-red">*</span>变更申请表
                    <a
                        href="https://corpverify-30042.sz.gfp.tencent-cloud.com/corp/2852199327/107/corp-2852199327-107-1629274976.pdf">下载变更申请表</a>
                    <span class="color-gray upload-data-content-title-limitdesc">（2M以内，支持png、jpg、jpeg格式）</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" frame-desc="变更申请表照片" :upload-id="4" />
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" frame-desc="法人手持变更申请表照片" :upload-id="5" />
                </div>
            </div>
            <!-- 补充资质附件 -->
            <div class="supplement each-upload">
                <div class="upload-data-content-title">
                    补充资质附件<span class="color-gray upload-data-content-title-limitdesc">（2M以内，支持png、jpg、jpeg格式）</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        inner-desc="点击选择或拖动文件到此区域" frame-desc="" :upload-id="6" />
                </div>
            </div>
        </div>
        <div class="upload-data-bottom">
            <v-button status="default" size="large" @click="previousStep">
                上一步
            </v-button>
            <v-button status="primary" size="large" style="margin:0 20px" @click="submitFile">
                提交
            </v-button>
            <v-button status="default" size="large" @click="cancel">
                取消
            </v-button>
        </div>
    </div>
</template>

<script>
import uploadFrame from './uploadFrame.vue';
export default {
    components: {
        uploadFrame,
    },
    props: {
        contact: {
            type: Object,
            default: () => { },
        },
        newQQ: {
            type: String,
            default: '',
        },
        newPhone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            // 上传文件的数组，用于判断子组件中都有哪些上传了数据
            uploadArr: {
                0: {},
                1: {},
                2: {},
                3: {},
                4: {},
                5: {},
                6: {},
            },
            // 是否点击了提交按钮，因为不点击提交按钮的时候不提示文件为空，点击了之后再提示用户某些文件必须上传不能为空
            isClickSubmit: false,
            // 图片上传Url
            uploadUrl: '/mng/account/contacts/uploadContactImg',
            // 文件提交Url
            submitUrl: '/mng/account/contacts/updateAdminContact',
            // 点击了删除的时候需要控制页面不能滑动
            isStopScroll: false,
        };
    },
    methods: {
        /**
         * 点击上一步
         * @return {void}
         */
        previousStep() {
            // const selectTab1 = document.getElementsByClassName('mpop_step_1')[0];
            // selectTab1.classList.add('active');
            // const selectTab2 = document.getElementsByClassName('mpop_step_2')[0];
            // selectTab2.classList.remove('active');
            this.$parent.$parent.clickPreviousStep();
        },
        cancel() {
            this.$parent.$parent.cancel();
        },

        /**
         * 更新上传文件数组中的value
         * @param {number} uploadId 上传的文件id
         * @param {Object} file 上传的文件信息
         * @return {void}
         */
        changeUploadArr(uploadId, file) {
            // 如果上传成功的文件id已经存在
            // 8.13 这里最后会把所有上传完成的数据存在这里，然后需要在点击提交的时候把这些数据带上，发一个ajax请求，然后刷新主页面，主页面里面有个请求，增加了两个参数，把这个参数一拿，放到顶部那个小条里面就完事了
            this.uploadArr[uploadId] = file;
        },

        /**
         * 上传文件，内部包括检测必要文件是否都上传成功、上传网络请求是否成功返回、关闭当前弹窗
         * @return {void}
         */
        submitFile() {
            this.isClickSubmit = true;
            const noUploadArr = [];
            for (const key in this.uploadArr) {
                if (Object.keys(this.uploadArr[key]).length === 0 && noUploadArr.indexOf(key) == -1) {
                    noUploadArr.push(key);
                }
            }
            // 除了最后一个文件，其他的文件都需要上传
            // eslint-disable-next-line no-mixed-operators
            if (noUploadArr.length === 1 && noUploadArr[0] === '6' || !noUploadArr.length) {
                this.$ajax.post(this.submitUrl, {
                    oldAdminQQ: this.contact.admin_qq,
                    newAdminQQ: this.newQQ,
                    oldPhone: this.contact.mobile,
                    newPhone: this.newPhone,
                    businessLicense: this.uploadArr[0] || '',
                    legalPersonLicenceFront: this.uploadArr[1] || '',
                    legalPersonLicenceBack: this.uploadArr[2] || '',
                    legalPersonLicenceHold: this.uploadArr[3] || '',
                    apply: this.uploadArr[4] || '',
                    applyHold: this.uploadArr[5] || '',
                    othorAttachment: this.uploadArr[6] || '',
                }).then((res) => {
                    if (res.code == 0) {
                        this.$message.success('提交成功');
                        this.closePanel();
                        // 提交完成之后需要刷新页面？
                        window.location.reload();
                    } else if (res.code && res.code !== 0 && res.message) {
                        this.$message.error(res.message);
                        return;
                    } else {
                        this.$message.error('提交失败');
                        return;
                    }
                });
            } else {
                this.$message.error('请检查是否有必填项未填');
            }
        },

        /**
         * 关闭弹框、由于弹窗是由lbf老框架写的，所以需要获取一下dom元素操作一下
         * @return {void}
         */
        closePanel() {
            this.cancel();
        },

        /**
         * 内容滑动控制
         * @param {boolen} status 要控制是否能够滑动
         * @return {void}
         */
        stopScrollControl(status) {
            this.isStopScroll = status;
        },
    },
};
</script>

<style lang="less" scoped>
.upload-data {
    width: 472px;
    overflow-x: hidden;
}

.color-red {
    color: #FF4222;
}

.color-gray {
    color: #A8ABB3;
}

.upload-data-inner {
    max-height: 444px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 0 30px 4px;

    &-stopscroll {
        overflow-y: hidden;
    }
}

.upload-data-content-title {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 1;
    text-align: left;
    margin: 8px 0;

    &-limitdesc {
        font-size: 12px;
        line-height: 17px;
    }
}

.upload-data-bottom {
    width: 100%;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.each-upload:first-child {
    padding-top: 12px;
}

.each-upload {
    padding-top: 23px;
}

.flex-box {
    display: flex;
}
</style>
